import { SimpleIconProps } from '../types';

export const IconBug = (props: SimpleIconProps) => {
  return (
    <svg fill="none" height="16" role="img" viewBox="0 0 16 16" width="16" {...props}>
      <path
        d="M8.6 12.74C9.96932 12.462 11 11.2514 11 9.8V8C11 7.5794 10.9138 7.17314 10.7508 6.8H5.24923C5.08615 7.17314 5 7.5794 5 8V9.8C5 11.2514 6.03066 12.462 7.4 12.74V9.2H8.6V12.74ZM4.12148 11.4144C3.91437 10.9174 3.8 10.372 3.8 9.8H2V8.6H3.8V8C3.8 7.61438 3.85197 7.24088 3.94928 6.88616L2.62154 6.11961L3.22154 5.08038L4.43382 5.78029C4.47197 5.71912 4.51165 5.65901 4.55281 5.6H11.4472C11.4883 5.65901 11.528 5.71912 11.5662 5.78029L12.7785 5.08038L13.3785 6.11961L12.0507 6.88616C12.148 7.24088 12.2 7.61438 12.2 8V8.6H14V9.8H12.2C12.2 10.372 12.0856 10.9174 11.8785 11.4144L13.3785 12.2804L12.7785 13.3196L11.263 12.4446C10.4929 13.3936 9.3173 14 8 14C6.68272 14 5.50707 13.3936 4.73703 12.4446L3.22154 13.3196L2.62154 12.2804L4.12148 11.4144ZM5.6 4.4C5.6 3.07452 6.67452 2 8 2C9.32546 2 10.4 3.07452 10.4 4.4H5.6Z"
        fill="#2774AE"
      />
    </svg>
  );
};
